import { Card, CardBody } from '@/components/ui/Card'
import { useColorModeValue } from '@/components/ui/color-mode'
import { ROUTES } from '@/constants/routes'
import { Box, Heading, HStack, IconButton } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { FiArrowLeft } from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'
import { LeadForm } from '../components/LeadForm'
import { useCreateLead } from '../hooks/useLeads'

/**
 * Lead Create Page
 * Create a new lead
 */
export function LeadCreate() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const cardBg = useColorModeValue('white', 'gray.800')
  const createMutation = useCreateLead()

  const handleCreate = async (data) => {
    const result = await createMutation.mutateAsync(data)
    // API response format: { success, data: { uuid, ... } }
    const leadUuid = result?.data?.uuid || result?.uuid
    // Delay navigation to allow toast to be visible
    setTimeout(() => {
      if (leadUuid) {
        navigate(`/leads/${leadUuid}`)
      } else {
        navigate(ROUTES.LEADS)
      }
    }, 1500)
  }

  const handleCancel = () => {
    navigate(ROUTES.LEADS)
  }

  return (
    <Box>
      {/* Header */}
      <HStack justify="space-between" mb={ 6 }>
        <HStack spacing={ 3 }>
          <IconButton
            onClick={ () => navigate(ROUTES.LEADS) }
            variant="ghost"
            aria-label="Back to leads"
          >
            <Box as={ FiArrowLeft } />
          </IconButton>
          <Heading size="lg">{t('leads.createNewLead')}</Heading>
        </HStack>
      </HStack>

      {/* Content */}
      <Card bg={ cardBg }>
        <CardBody>
          <LeadForm
            onSubmit={ handleCreate }
            onCancel={ handleCancel }
            isLoading={ createMutation.isPending }
          />
        </CardBody>
      </Card>
    </Box>
  )
}

export default LeadCreate
